/**
 * propertyTimezone.context.ts
 * React context for the property's IANA timezone string.
 * Exported separately to satisfy the react-refresh/only-export-components rule.
 */

import { createContext } from 'react';

interface PropertyTimezoneContextValue {
  timezone: string;
}

export const PropertyTimezoneContext = createContext<PropertyTimezoneContextValue | undefined>(undefined);
